import React, { useContext } from "react"
import { Div, Text } from "atomize"
import { theme, productionProjectID } from "../settings/config"
import { modalContext } from "../providers/modal.provider"
import { currentDevVersion, devVersionLabel } from "../devApp/devApp"

// Sapere su quale ambiente si sta lavorando non può dipendere dalla
// memoria: la disciplina di controllare regge finché non si è di fretta, ed
// è lì che nascono gli allievi di prova dentro il database vero.
//
// Due situazioni da segnalare, e sono opposte: sto usando un banco di prova
// (quindi quello che faccio non conta), oppure sto lavorando in locale ma
// sui dati veri (quindi conta eccome). L'app pubblicata non mostra niente.
//
// Nell'app dev (src/devApp) dice anche quale versione si sta provando —
// DEV su master, il numero su una PR — e toccandola si cambia.
const projectID = process.env.REACT_APP_FIREBASE_PROJECT_ID
const isDevelopmentServer = process.env.NODE_ENV === "development"
const isProductionData = projectID === productionProjectID

function EnvironmentBadge() {
	const Modal = useContext(modalContext)
	const devVersion = currentDevVersion()

	if (!projectID) return null
	if (isProductionData && !isDevelopmentServer) return null

	const onRealData = isProductionData

	return (
		<Div
			tag={devVersion ? "button" : "div"}
			type={devVersion ? "button" : undefined}
			onClick={devVersion ? () => Modal.open("devVersions") : undefined}
			aria-label={devVersion ? "Cambia la versione da provare" : undefined}
			pos="fixed"
			top="calc(0.5rem + env(safe-area-inset-top))"
			left="0"
			zIndex="1000"
			bg={onRealData ? theme.colors.red : theme.colors.warning}
			p="0.15rem 0.6rem 0.15rem 0.5rem"
			rounded="r-20px"
			border="0"
			title={projectID}
			style={{
				pointerEvents: devVersion ? "auto" : "none",
				cursor: devVersion ? "pointer" : undefined,
				opacity: 0.9,
			}}>
			<Text textSize="caption" textWeight="bold" textColor={theme.colors.white}>
				{onRealData ? "DATI VERI" : devVersion ? devVersionLabel(devVersion) : "DEV"}
			</Text>
		</Div>
	)
}

export default EnvironmentBadge
